//import http from "./AxiosConfig";
import React from "react";
import axios from "axios";

export default class ConnectionServer extends React.Component {
    static StartCodeErrorAPI = 500;
    static Accept = 200;
    static SrverNotResonse = "سرور در حال حاظر قادر به پاسخ گویی نمی باشد";
    static UserStartError = 400;
    static UserEndError = 500;
    static EndCodeErrorAPI = 10000000;
    static Nodata = "NO";
    static endsession = 1056;
    static BadRequest = "مشکلی پیش آمده، لطفا بعدا تلاش کنید";

    static ErrorConnection = 1;
    static ErrorURL = 3;

    static ConnectionError(Code, Type) {
        if (Type === this.ErrorConnection) alert("ErrorConnection");
        else if (Type === this.ErrorURL) alert("ErrorURL");
        else if (Code < ConnectionServer.StartCodeErrorAPI)
            alert("StartCodeErrorAPI");
        else if (Type === this.endsession) {
            window.open("/", "_self");
            sessionStorage.clear();
        }
    }

    static async Connection_AXIOS_GetJson(URlString, Option) {
        var result = [200, ""];
        const res = await axios.get(URlString, Option).catch(function (Error) {
            if (Error.response != undefined) {
                result[0] = Error.response.status;
                result[1] = Error.response.data.message;
                result[2] = "";
                ConnectionServer.ConnectionError(result[1], result[0]);
            } else {
                result[0] = 3;
                result[1] = ConnectionServer.BadRequest;
                result[2] = "";
            }
        });

        if (result[0] !== ConnectionServer.Accept) {
            if (result[0] > ConnectionServer.StartCodeErrorAPI) {
                result[1] = ConnectionServer.SrverNotResonse;
                result[2] = ConnectionServer.Nodata;
            } else if (
                result[0] >= ConnectionServer.UserStartError &&
                result[0] < ConnectionServer.UserEndError
            ) {
                result[2] = ConnectionServer.Nodata;
            }
        } else {
            if(URlString.indexOf("shad")>-1)
            {
                if(res.data.isSuccess==true)
                    result[0] = "200";
                else
                    result[0] = "20000";
                result[1] = res.data.message;
                result[2] = res.data;
            }
            else
            {
                result[0] = res.status;
                result[1] = res.data.message;
                result[2] = res.data;
            }
        }

        return result;
    }

    static async Connection_AXIOS_DeleteJson(URlString, Body, Option) {
        var result = [200, ""];
        if (Body !== null) {
            const res = await axios
                .delete(URlString, Body, Option)
                .catch(function (Error) {
                    result[0] = Error.response.status;
                    result[1] = Error.response.data.message;
                    result[2] = "";
                    ConnectionServer.ConnectionError(result[1], result[0]);
                });
            if (result[0] !== ConnectionServer.Accept) {
                if (result[0] > ConnectionServer.StartCodeErrorAPI) {
                    result[1] = ConnectionServer.SrverNotResonse;
                    result[2] = ConnectionServer.Nodata;
                } else if (
                    result[0] >= ConnectionServer.UserStartError &&
                    result[0] < ConnectionServer.UserEndError
                ) {
                    result[2] = ConnectionServer.Nodata;
                }
            } else {
                result[0] = res.status;
                result[1] = res.data.message;
                result[2] = res.data;
            }
        } else {
            result = [5, "اطلاعاتی برای ارسال دریافت نشده است", ""];
            ConnectionServer.ConnectionError(result[1], result[0]);
        }
        return result;
    }

    static async Connection_AXIOS_UpdateJson(URlString, Body, Option) {
        var result = [200, ""];
        if (Body !== null) {
            const res = await axios
                .put(URlString, Body, Option)
                .catch(function (Error) {
                    result[0] = Error.response.status;
                    result[1] = Error.response.data.message;
                    result[2] = "";
                    ConnectionServer.ConnectionError(result[1], result[0]);
                });
            if (result[0] !== ConnectionServer.Accept) {
                if (result[0] > ConnectionServer.StartCodeErrorAPI) {
                    result[1] = ConnectionServer.SrverNotResonse;
                    result[2] = ConnectionServer.Nodata;
                } else if (
                    result[0] >= ConnectionServer.UserStartError &&
                    result[0] < ConnectionServer.UserEndError
                ) {
                    result[2] = ConnectionServer.Nodata;
                }
            } else {
                result[0] = res.status;
                result[1] = res.data.message;
                result[2] = res.data;
            }
        } else {
            result = [5, "اطلاعاتی برای ارسال دریافت نشده است", ""];
            ConnectionServer.ConnectionError(result[1], result[0]);
        }
        return result;
    }

    static async Connection_AXIOS_InsertJson(URlString, Body, Option) {
        var result = [200, ""];
        if (Body !== null) {
            const res = await axios
                .post(URlString, Body, Option)
                .catch(function (Error) {
                    if (Error.response != undefined) {
                        result[0] = Error.response.status;
                        result[1] = Error.response.data.message;
                        result[2] = "";
                        ConnectionServer.ConnectionError(result[1], result[0]);
                    } else {
                        result[0] = 3;
                        result[1] = ConnectionServer.BadRequest;
                        result[2] = "";
                    }
                });
            if (result[0] !== ConnectionServer.Accept) {
                if (result[0] > ConnectionServer.StartCodeErrorAPI) {
                    result[1] = ConnectionServer.SrverNotResonse;
                    result[2] = ConnectionServer.Nodata;
                } else if (
                    result[0] >= ConnectionServer.UserStartError &&
                    result[0] < ConnectionServer.UserEndError
                ) {
                    result[2] = ConnectionServer.Nodata;
                }
            } else {
                result[0] = res.status;
                result[1] = res.data.message;
                result[2] = res.data;
            }
        } else {
            result = [5, "اطلاعاتی برای ارسال دریافت نشده است", ""];
            ConnectionServer.ConnectionError(result[1], result[0]);
        }
        return result;
    }
}
